import NiceModal from "@ebay/nice-modal-react";
import { adminRequester } from "App";
import AdminCustomButton from "components/buttons/AdminCustomButton";
import InputNumber from "components/inputs/InputNumber";
import InputText from "components/inputs/InputText";
import InputTextarea from "components/inputs/InputTextarea";
import P from "components/P";

import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import VerticalFlex from "layouts/flex/VerticalFlex";
import PaddingWrapper from "layouts/wrapper/PaddingWrapper";
import _ from "lodash";
import ModalBase from "modals/base/ModalBase";
import { useRef } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
const getDate = (date) => {
  date = new Date(date);
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(
    2,
    "0"
  )}-${String(date.getDate()).padStart(2, "0")} ${String(
    date.getHours()
  ).padStart(2, "0")}:${String(date.getMinutes()).padStart(2, "0")}`;
};

const AddPointModal = NiceModal.create((props) => {
  const { t } = useTranslation();
  // const { isMobile } = useContext(BrowserDetectContext);
  const { id, point, email, name, setReload } = props;
  const [withHeader, withFooter] = [false, false];
  const [width, height] = ["480px", "250px"];
  const clickOutsideToClose = true;
  const modal = useRef();
  const inputs = useRef([]);
  return (
    <ModalBase
      borderRadius={"10px"}
      headerStyle
      ref={modal}
      width={width}
      height={height}
      withHeader={withHeader}
      withFooter={withFooter}
      clickOutsideToClose={clickOutsideToClose}
    >
      <PaddingWrapper padding={30}>
        <VerticalFlex gap={10} flexStart>
          <FlexChild>
            <P>To. {name}</P>
          </FlexChild>
          <FlexChild>
            <HorizontalFlex>
              <FlexChild width={100}>
                <P>포인트</P>
              </FlexChild>
              <FlexChild>
                <InputNumber
                  validable={false}
                  hideArrow
                  min={-9999999999999999}
                  max={9999999999999999}
                  ref={(el) => (inputs.current[0] = el)}
                />
              </FlexChild>
            </HorizontalFlex>
          </FlexChild>
          <FlexChild>
            <HorizontalFlex>
              <FlexChild width={100}>
                <P>사유</P>
              </FlexChild>
              <FlexChild>
                <InputTextarea
                  rows={3}
                  ref={(el) => (inputs.current[1] = el)}
                />
              </FlexChild>
            </HorizontalFlex>
          </FlexChild>
          <FlexChild>
            <HorizontalFlex justifyContent="center" gap={10}>
              <FlexChild width="max-content">
                <AdminCustomButton
                  text="추가"
                  onClick={() => {
                    const p = Number(inputs.current[0].getValue());
                    const total = Number(point || 0) + p;

                    adminRequester.createLog(
                      {
                        key: `${email}_${new Date().getTime()}`,
                        type: "포인트",
                        search: email,
                        metadata: {
                          point: p,
                          total: total,
                          memo: inputs.current[1].getValue(),
                        },
                      },
                      (result) => {
                        if (result?.log) {
                          adminRequester.updateCustomer(
                            id,
                            {
                              point: total,
                            },
                            () => {
                              setReload(true);
                              modal.current.close();
                            }
                          );
                        } else {
                          toast.error(
                            "문제가 발생하였습니다. 문의 부탁드립니다.",
                            { autoClose: 1000 }
                          );
                          setReload(true);
                          modal.current.close();
                        }
                      }
                    );
                  }}
                />
              </FlexChild>
              <FlexChild width="max-content">
                <AdminCustomButton
                  text="취소"
                  onClick={() => modal.current.close()}
                />
              </FlexChild>
            </HorizontalFlex>
          </FlexChild>
        </VerticalFlex>
      </PaddingWrapper>
    </ModalBase>
  );
});

export default AddPointModal;
